export type ConsolidatedPATStatusKey =
  | "suspended"
  | "passed"
  | "expired"
  | "qualifying"
  | "failed"
  | "in_progress"
  | "not_started";

const CONSOLIDATED_PAT_STATUS_LABELS: Record<ConsolidatedPATStatusKey, string> = {
  suspended: "Suspended",
  passed: "Passed",
  expired: "Expired",
  qualifying: "Qualifying",
  failed: "Failed",
  in_progress: "In Progress",
  not_started: "Not Started"
};

export function getConsolidatedPATStatusLabel(statusKey: ConsolidatedPATStatusKey): string {
  return CONSOLIDATED_PAT_STATUS_LABELS[statusKey];
}

export function getPATSubmissionStatusTag(result?: string | null): {
  label: string;
  statusKey: ConsolidatedPATStatusKey | "registered" | "pending" | "unknown";
} {
  const normalizedResult = result?.toLowerCase();

  switch (normalizedResult) {
    case "passed":
      return { label: getConsolidatedPATStatusLabel("passed"), statusKey: "passed" };
    case "qualified":
      return { label: getConsolidatedPATStatusLabel("qualifying"), statusKey: "qualifying" };
    case "failed":
      return { label: getConsolidatedPATStatusLabel("failed"), statusKey: "failed" };
    case "expired":
      return { label: getConsolidatedPATStatusLabel("expired"), statusKey: "expired" };
    case "pending":
      return { label: "Pending", statusKey: "pending" };
    case "registered":
      return { label: "Registered", statusKey: "registered" };
    default:
      return { label: result || "", statusKey: "unknown" };
  }
}
